"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyAddressesResponse$ = exports.PropertyAddressesResponse$outboundSchema = exports.PropertyAddressesResponse$inboundSchema = void 0;
exports.propertyAddressesResponseToJSON = propertyAddressesResponseToJSON;
exports.propertyAddressesResponseFromJSON = propertyAddressesResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const propertyaddresseswrapper_js_1 = require("./propertyaddresseswrapper.js");
/** @internal */
exports.PropertyAddressesResponse$inboundSchema = z.object({
    data: z.array(propertyaddresseswrapper_js_1.PropertyAddressesWrapper$inboundSchema),
});
/** @internal */
exports.PropertyAddressesResponse$outboundSchema = z.object({
    data: z.array(propertyaddresseswrapper_js_1.PropertyAddressesWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyAddressesResponse$;
(function (PropertyAddressesResponse$) {
    /** @deprecated use `PropertyAddressesResponse$inboundSchema` instead. */
    PropertyAddressesResponse$.inboundSchema = exports.PropertyAddressesResponse$inboundSchema;
    /** @deprecated use `PropertyAddressesResponse$outboundSchema` instead. */
    PropertyAddressesResponse$.outboundSchema = exports.PropertyAddressesResponse$outboundSchema;
})(PropertyAddressesResponse$ || (exports.PropertyAddressesResponse$ = PropertyAddressesResponse$ = {}));
function propertyAddressesResponseToJSON(propertyAddressesResponse) {
    return JSON.stringify(exports.PropertyAddressesResponse$outboundSchema.parse(propertyAddressesResponse));
}
function propertyAddressesResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyAddressesResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyAddressesResponse' from JSON`);
}
//# sourceMappingURL=propertyaddressesresponse.js.map